interface DocumentSignatureProps {
  color?: string;
}

const DocumentSignature = ({ color }: DocumentSignatureProps) => {
  const fillColor = color || '#1F5C91';
  
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.41669 11.5C8.00247 11.5 7.66669 11.8358 7.66669 12.25C7.66669 12.6642 8.00247 13 8.41669 13C8.8309 13 9.16669 12.6642 9.16669 12.25C9.16669 11.8358 8.8309 11.5 8.41669 11.5ZM7.66669 15.25C7.66669 14.8358 8.00247 14.5 8.41669 14.5C8.8309 14.5 9.16669 14.8358 9.16669 15.25C9.16669 15.6642 8.8309 16 8.41669 16C8.00247 16 7.66669 15.6642 7.66669 15.25ZM10.6667 12.25C10.6667 11.8358 11.0025 11.5 11.4167 11.5H14.4704C14.8847 11.5 15.2204 11.8358 15.2204 12.25C15.2204 12.6642 14.8847 13 14.4704 13H11.4167C11.0025 13 10.6667 12.6642 10.6667 12.25ZM11.4167 14.5C11.0025 14.5 10.6667 14.8358 10.6667 15.25C10.6667 15.6642 11.0025 16 11.4167 16H14.4704C14.8847 16 15.2204 15.6642 15.2204 15.25C15.2204 14.8358 14.8847 14.5 14.4704 14.5H11.4167ZM6.91669 2C5.67405 2 4.66669 3.00736 4.66669 4.25V17.25C4.66669 18.4926 5.67405 19.5 6.91669 19.5H15.9167C17.1593 19.5 18.1667 18.4926 18.1667 17.25V8.86885C18.1667 8.27211 17.9296 7.69981 17.5077 7.27786L12.8888 2.65901C12.4669 2.23705 11.8946 2 11.2978 2H6.91669ZM6.16669 4.25C6.16669 3.83579 6.50247 3.5 6.91669 3.5H11.1706V6.74753C11.1706 7.99017 12.178 8.99753 13.4206 8.99753H16.6667V17.25C16.6667 17.6642 16.3309 18 15.9167 18H6.91669C6.50247 18 6.16669 17.6642 6.16669 17.25V4.25ZM12.6706 6.74753V4.56209L15.606 7.49753H13.4206C13.0064 7.49753 12.6706 7.16174 12.6706 6.74753ZM9.41756 22C8.4379 22 7.60447 21.3739 7.29559 20.5H15.9176C17.7125 20.5 19.1676 19.0449 19.1676 17.25V8.93689L20.0086 9.77788C20.4305 10.1998 20.6676 10.7721 20.6676 11.3689V17.25C20.6676 19.8734 18.5409 22 15.9176 22H9.41756Z"
        fill={fillColor}
      />
    </svg>
  );
};
export default DocumentSignature;
